import { render, staticRenderFns } from "./AccessFunctionality.vue?vue&type=template&id=1e8cafb3&scoped=true"
import script from "./AccessFunctionality.vue?vue&type=script&lang=js"
export * from "./AccessFunctionality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8cafb3",
  null
  
)

export default component.exports